import './index.css'
import React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import type { NativeTagWithCategory } from 'types/track'
import { updateExplorer } from '@disco/state-management/actions/ExplorerActions'
import {
  clearSearch,
  updateSearchParams,
} from '@disco/state-management/actions/SearchActions'
import mixpanel from '@disco/api/mixpanel'
import { checkSetFilters } from '@disco/utils/search'
import { getSearchFacetTags } from '@disco/state-management/selectors/search'
import { getNativeTags } from '@disco/state-management/selectors/tags'
import Button from 'components/ui/button'
import FacetedTag from './faceted-tag'
import HorizScroller from './horiz-scroller'

const mapStateToProps = state => ({
  nativeTags: getNativeTags(state),
  availableTags: getSearchFacetTags(state),
  search: state.search,
})

const actions = {
  updateExplorer,
  updateSearchParams,
  clearSearch,
}

const connector = connect(mapStateToProps, actions)
type ReduxProps = ConnectedProps<typeof connector>
type Props = ReduxProps & {
  explorerWidth: number
  firstPaneVisible: boolean
}

const FacetedRow = (props: Props) => {
  let facetNode: React.ReactElement | null = null
  if (props.search.searchedNativeTags.length === 0) return null

  // removing tags can leave the search without any criteria — in that case
  // clear the search entirely so the default panel is restored instead of
  // leaving stale results on screen
  const removeTags = (remainingIds: number[]) => {
    if (
      remainingIds.length === 0 &&
      !checkSetFilters({ ...props.search, nativeTags: remainingIds })
    ) {
      props.clearSearch(false)
      return
    }
    props.updateSearchParams({
      nativeTags: remainingIds,
    })
  }

  if (props.firstPaneVisible) {
    facetNode = (
      <div className="FacetedRow_Inner">
        <div>
          <Button
            appearance="icon"
            icon="arrow-left"
            caption="Back to search"
            onClick={() =>
              props.updateExplorer({
                activePane: 0,
              })
            }
          />
        </div>
      </div>
    )
  } else {
    const selectedTags = props.search.searchedNativeTags
      .map(id => {
        const tag = props.nativeTags.find(t => t.id === id)

        if (tag) {
          return tag
        }
      })
      .filter(Boolean)
    facetNode = (
      <div className="FacetedRow_Inner">
        <div className="FacetedRow_ScrollerCont">
          <HorizScroller>
            {selectedTags.map(f => (
              <FacetedTag
                key={f.id}
                selected
                tooltip={f.category.name}
                onClick={() => {
                  removeTags(props.search.nativeTags.filter(id => id !== f.id))
                }}
              >
                {f.name}
              </FacetedTag>
            ))}
            {props.availableTags.map(f => (
              <FacetedTag
                key={f.id}
                tooltip={f.category.name}
                onClick={() => {
                  mixpanel.sendPureEvent(
                    'Clicking on track tag (faceted & track pane)',
                    {
                      Tags: [f.name],
                      Type: 'Search results',
                    },
                  )
                  props.updateSearchParams({
                    nativeTags: props.search.nativeTags.concat(f.id),
                  })
                }}
              >
                {f.name}
              </FacetedTag>
            ))}
          </HorizScroller>
        </div>
        <div className="FacetedRow_ClearCont">
          <Button
            icon="clear"
            appearance="link"
            caption="Clear tags"
            onClick={() => removeTags([])}
          />
        </div>
      </div>
    )
  }

  return (
    <div
      style={{
        width: props.explorerWidth,
      }}
    >
      {facetNode}
    </div>
  )
}

export default connector(FacetedRow)
